import React from 'react';
import { Step } from '../../../../types/registration';
import EventOverview from "../steps/EventOverview";
import DancersStep from "../steps/DancersStep";
import TeachersStep from "../steps/TeachersStep";
import ObserversStep from "../steps/ObserversStep";
import CompetitionStep from "../steps/CompetitionStep";
import ReviewStep from "../steps/ReviewStep";
import PaymentStep from "../steps/PaymentStep";
import SuccessStep from "../steps/SuccessStep";

// Steps that should not be persisted to the backend
export const SKIP_PERSISTENCE_STEPS: string[] = ["success"];

// All possible steps - some may be excluded based on event configuration
export const ALL_STEPS: Step[] = [
  { id: "overview", label: "OVERVIEW", component: EventOverview, path: "overview" },
  { id: "competition", label: "ROUTINES", component: CompetitionStep, path: "routines" },
  { id: "dancers", label: "DANCERS", component: DancersStep, path: "dancers" },
  { id: "teachers", label: "TEACHERS", component: TeachersStep, path: "teachers" },
  { id: "observers", label: "OBSERVERS", component: ObserversStep, path: "observers" },
  { id: "review", label: "REVIEW", component: ReviewStep, path: "review" },
  { id: "payment", label: "PAYMENT", component: PaymentStep, path: "payment" },
  { id: "success", label: "SUCCESS", component: SuccessStep, path: "success" },
]; 